import "../../../assets/css/funcoes.css";
import { MdOutlineImageAspectRatio } from "react-icons/md";

function Arquivos({ active, name, onClick, data }) {
  return (
    <div
      onClick={() => onClick(data)}
      className={`active-item ${active ? "actived" : ""}`}
    >
      <span className="active-item-content">
        <MdOutlineImageAspectRatio size={15} color="var(--bs-primary)" />
        <span>{name}</span>
      </span>
    </div>
  );
}

export default Arquivos;
